import React from "react";
import { LIST_IMAGE } from "./constant";

const FooterImage = ({ isAuth }) => {
  const LayoutAuth = ({ children }) => {
    return isAuth ? (
      <div className="container-fluid px-2 px-md-4">
        <div className="w-80 float-end">{children}</div>
      </div>
    ) : (
      <div className="container-fluid p-100">{children}</div>
    );
  };

  return (
    <div className="clearfix bg-grey">
      <LayoutAuth>
        <div className="py-2 py-md-4">
          <div className="row row-cols-3 row-cols-sm-6 g-2">
            {LIST_IMAGE.map((item, index) => (
              <a key={index} href={item.path} className="col" target="_blank">
                <img src={item.image} alt={item.image} className="img-fluid" />
              </a>
            ))}
          </div>
        </div>
      </LayoutAuth>
    </div>
  );
};

export default FooterImage;
